/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Ocr_Processing_StatusInputs */



/**
* | output |
* | --- |
* | "Recognizing text in frame {current} of {total}" |
*
* @param {Ocr_Processing_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_processing_status = /** @type {((inputs: Ocr_Processing_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Processing_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Reconnaissance du texte dans le cadre ${i?.current} de ${i?.total}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Texterkennung im Frame ${i?.current} von ${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Riconoscimento del testo nel riquadro ${i?.current} di ${i?.total}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Распознавание текста в кадре ${i?.current} из ${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Reconociendo texto en el marco ${i?.current} de ${i?.total}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`识别帧 ${i?.current} 中的文本（帧 ${i?.total}）`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フレーム${i?.current}（${i?.total}内）のテキストを認識しています。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ्रेम ${i?.current} के ${i?.total} में टेक्स्ट को पहचानना`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Reconhecendo o texto no quadro ${i?.current} de ${i?.total}`)
	return /** @type {LocalizedString} */ (`Recognizing text in frame ${i?.current} of ${i?.total}`)
});